var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.03,
    y: 44.91,
    width: 152.62,
    height: 93.92,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190,165H26.63c-8.78,0-12.12-4.55-7.41-10.12l9-8.84c4.71-5.57,9.46-6.32,16.32-6.32H172.18c6.86,0,12.06.53,16.76,6.09l8.51,9.07C202.15,160.46,198.81,165,190,165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.11,82.42s-13.83-5.8-15.17,2.68c-1.7,10.77,14.87,4.31,15.47,13.68s-12.5,7.14-15.92,3.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.57,
    y1: 71.55,
    x2: 107.57,
    y2: 79.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.57,
    y1: 105.63,
    x2: 107.57,
    y2: 113.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.34,
    cy: 92.24,
    r: 34.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.46,
    y1: 81,
    x2: 79.67,
    y2: 72.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 135.71,
    y1: 113.21,
    x2: 124.91,
    y2: 105.16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeOnline);
export default __webpack_public_path__ + "static/media/FREE_ONLINE.041d5f58a37eeb015a812f048767b582.svg";
export { ForwardRef as ReactComponent };